import React, { useEffect, useState } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import LogIn from './LogIn';
import Dashboard from './Dashboard';
import SalesRec from './SalesRecord';
import NewSales from './NewSales';
import PurchaseRec from './PurchaseRecord'
import {Header} from './Header';
import ViewStock from './ViewStock';
import SavedForLater from './SavedForLater';
import SalesPerCustomer from './SalesPerCustomer';
import Report from './Report';
import TotalAndExpenses from './TotalAndExpenses';
import { StyleSheet, View } from 'react-native';
import { FirstTime, Backdated } from './DateTimeCheck';
import { Provider as PaperProvider, DefaultTheme } from "react-native-paper";

const Stack = createStackNavigator();
const darkColour='#2a2d3e';

const Entry = () => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const computerDateTime = new Date();
  const [resultReceived, setResultReceived] = useState('All good');
  const [showBackdated, setShowBackdated] = useState(true)
  const [isFirstTimeDisabled, setisFirstTimeDisabled] = useState(true)
  const [title, setTitle] = useState('');

  // const CheckDateTime = async () => {
  //   DEBUG(true);
  //   enablePromise(true);
  //   const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
    
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //     (await initDB).transaction((tx) => {
  //       tx.executeSql(
  //         'CREATE TABLE IF NOT EXISTS StoredDateTime (ID INTEGER PRIMARY KEY, DateTime TEXT NOT NULL)',
  //         []
  //       );
  //       tx.executeSql('SELECT DateTime FROM StoredDateTime WHERE ID = ?', [1], (_, results) => {
  //         if (results.rows.length > 0) {
  //           const storedDateTime = new Date(results.rows.item(0).DateTime);
  //           if (storedDateTime < computerDateTime) {
  //             tx.executeSql('UPDATE StoredDateTime SET DateTime = ? WHERE ID = ?', [computerDateTime.toISOString(), 1], (_, updateResults) => {
  //               // if (updateResults.rowsAffected > 0) {
  //                  setResultReceived('All good')
  //               // }
  //               resolve(updateResults); // Resolve the promise when the update is completed
  //             });
  //           } else {
  //             setResultReceived('Backdated')
  //             resolve(results); // Resolve the promise with the existing results
              
  //           }
  //         } else {
  //           tx.executeSql('INSERT INTO StoredDateTime (ID, DateTime) VALUES (?, ?)', [1, computerDateTime.toISOString()], (_, insertResults) => {
  //             // if (insertResults.rowsAffected > 0) {
  //                setResultReceived('First time')
  //             // }
  //             resolve(insertResults); // Resolve the promise when the insertion is completed
  //           });
  //         }
  //       });
  //     });
  //   } catch (Error:any) {
  //     setResultReceived ('Error')
  //     reject(Error)
  //     console.log(Error)
  //   }
  //   }); 
  // };

  // useEffect(() => {
  //   const handleCheckDateTime = async () => {
  //     await CheckDateTime();
  //   };
  //   handleCheckDateTime();
  // }, []);
  
  useEffect(() => {
    const fetchDateTimeFromComputer = async () => {
      const dateTimeFromComputer = new Date(); 
      setCurrentDateTime(dateTimeFromComputer);
    };
    fetchDateTimeFromComputer();
    const timerId = setInterval(() => {
      setCurrentDateTime((prevDateTime) => {
        const newDateTime = new Date(prevDateTime);
        newDateTime.setSeconds(newDateTime.getSeconds() + 1);
        const title = 'Stock Aware'
        return newDateTime;
      });
    }, 1000);
    return () => clearInterval(timerId);
  }, []);

  const navContent = (
    <NavigationContainer>
      <Stack.Navigator initialRouteName='LogIn' screenOptions={{ title: `${currentDateTime.toString()}`, headerShown:false }}>
        <Stack.Screen name="Dashboard" component={Dashboard} options={{header: () => <Header />, headerShown:true}}/>
        <Stack.Screen name="ViewStock" component={ViewStock} options={{header: () => <Header />, headerShown:true}} />
        <Stack.Screen name="SalesRecord" component={SalesRec} options={{header: () => <Header />, headerShown:true}} />
        <Stack.Screen name="LogIn" component={LogIn}/>
        <Stack.Screen name="NewSales" component={NewSales} options={{header: () => <Header />, headerShown:true}} />
        <Stack.Screen name="PurchaseRecord" component={PurchaseRec} options={{header: () => <Header />, headerShown:true}}/>
        <Stack.Screen name="SavedForLater" component={SavedForLater} options={{header: () => <Header />, headerShown:true}}/>
        <Stack.Screen name="SalesPerCustomer" component={SalesPerCustomer} options={{header: () => <Header />, headerShown:true}}/>
        <Stack.Screen name="Report" component={Report} options={{header: () => <Header />, headerShown:true}} />
        <Stack.Screen name="TotalAndExpenses" component={TotalAndExpenses} options={{header: () => <Header />, headerShown:true}}/>
      </Stack.Navigator>
    </NavigationContainer>
  );

  const handleFirstTime = () => {
    setisFirstTimeDisabled((prev) => !prev)
  }

  const handleBackdated = () => {
    setShowBackdated((prev) => !prev)
  }

  const theme = {
    ...DefaultTheme,
    colors: {
      ...DefaultTheme.colors,
      backdrop: 'rgba(0, 0, 0, 0.6)', // Customize the overlay color here
    },
  };
 
  return (
    <PaperProvider theme={theme}>
      <View style={{ width: '100%', height: '100%' }}>
        {resultReceived === 'Backdated' && (
          <View style={{ width: '100%', height: '100%' }}>
            {navContent}
            <Backdated onClicked={handleBackdated} backdated={showBackdated} />
          </View>
        )}
        {resultReceived === 'First time' && (
          <View style={{ width: '100%', height: '100%' }}>
            {navContent}
            <FirstTime onClicked={handleFirstTime} firstTime={isFirstTimeDisabled} />
          </View>
        )}
        {resultReceived === 'All good' && navContent}
      </View>
    </PaperProvider>
  );
};

const stylesBox = StyleSheet.create ({
  modalContainer: {
		marginLeft:500,
		marginTop: -50,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'white',
		width:580, 
		height:400, 
		borderWidth:1, 
		borderColor:darkColour, 
		borderRadius:10, 
  },
})

export default Entry;

// const CheckDateTime = async () => {
//   DEBUG(true);
//   enablePromise(true);
//   const initDB = openDatabase({ name: 'StockAware.db', location: 'default' });
//   (await initDB).transaction((tx) => {
//     tx.executeSql('SELECT DateTime FROM records WHERE ID = ?', [1], (_, results) => {
//       if (results.rows.length > 0) {
//         const storedDateTime = new Date(results.rows.item(0).DateTime);
//         if (storedDateTime < computerDateTime) {
//           console.log('Updating the row with the new date and time...');
//           tx.executeSql('UPDATE records SET DateTime = ? WHERE ID = ?', [computerDateTime.toISOString(), 1]);
//         } else {
//           console.log('Stored date and time is not earlier than the current date and time.');
//           //formlike response that the date is not correct
//         }
//       } else {
//         console.log('No row found with ID 1. Inserting a new row...');
//         tx.executeSql('INSERT INTO records (id, datetime) VALUES (?, ?)', [1, computerDateTime.toISOString()]);
//         //first time
//       }
//     });
//  //  tx.executeSql('INSERT OR REPLACE INTO records (id, datetime) VALUES (?, ?)', [1, new Date().toISOString()]);
//   });
// }

// {resultReceived === 'Backdated' && (
//   <PaperProvider>
//     <View style ={{width:'100%', height: '100%'}}>
//       <Portal>
//           <Modal visible={showBackdated} onDismiss={() => {setShowBackdated(false)}} contentContainerStyle={stylesBox.modalContainer}>
//             <Backdated/>
//           </Modal>
//       </Portal>
//     </View>
//   </PaperProvider>
// )}
// {resultReceived === 'First time' && ( 
//   <PaperProvider>
//   <View style ={{width:'100%', height: '100%'}}>
//     <Portal>
//         <Modal visible={showBackdated} onDismiss={() => {setShowBackdated(false)}} contentContainerStyle={stylesBox.modalContainer}>
//           <Backdated/>
//         </Modal>
//     </Portal>
//   </View>
// </PaperProvider>
//  )}
//  {resultReceived === 'Error' && (
//   <Text>An error occurred while checking the date and time.</Text>
// )}
//  {resultReceived === 'All good' && ( navContent )}
